import * as React from 'react';

import { SegmentLabel } from '@acceligentllc/storybook';

import { previewSectionClass, previewSectionClassColumn6, previewSectionClassRow } from '../../helpers';

type Props = {
	jobHazardSummary: Nullable<string>;
};

const JobHazardSummarySection: React.FC<Props> = ({ jobHazardSummary }) => {
	return (
		<div className={previewSectionClass}>
			<SegmentLabel
				label="Job Hazard Summary"
				tooltip="An editable form for recording hazards identified for this job, helping ensure safe execution and compliance with site regulations."
			/>
			<div className={previewSectionClassRow}>
				<div className={previewSectionClassColumn6}>
					<b>{jobHazardSummary ?? '-'}</b>
				</div>
			</div>

		</div>
	);
};

export default React.memo(JobHazardSummarySection);
